
import { Mixins, Component, Watch } from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/org';
import { ISetting } from '@/types/set.d';
import bModal from './components/bModal.vue';
import tableMixin from './tableMixin';


@Component({
  components: {
    Pagination,
    bModal,
  },
})
export default class Setting extends Mixins(tableMixin) {
  private addBtn: Array<IBTNCONF> = [{
    title: '新增',
    name: '/set:add',
    icon: 'plus',
    callback: this.handleAddForm,
    log: {
      name: '系统配置 - 新增',
      component: 'set/bModal',
    },
  }];

  private visible: boolean = false;

  private title: string = '修改配置';

  private form: ISetting = {
    key: '',
    value: '',
    remark: '',
  };

  /**
   * @author ruixue
   * @desc 添加配置
   */
  handleAddForm() {
    this.title = '添加配置';
    this.visible = true;
  }

  /**
   * @author ruixue
   * @desc 编辑配置
   * @param { any } row 行数据
   */
  handleUpdateForm(row: any) {
    this.form = {
      id: row.id,
      key: row.key,
      value: row.value,
      remark: row.remark,
    };
    this.title = '编辑配置';
    this.visible = true;
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
